import type { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

/** The small bordered button every header chip is built on. */
export const Chip: FC<ComponentProps<"button">> = ({ className, ...props }) => (
  <button
    type="button"
    {...props}
    className={cn(
      "inline-flex h-7 max-w-48 shrink-0 items-center gap-1.5 rounded-md border border-border bg-background px-2 text-xs text-foreground transition-colors select-none",
      "hover:bg-muted focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:outline-none disabled:opacity-60",
      "data-[state=open]:bg-muted",
      className
    )}
  />
);

/**
 * Label used for the property rows in the details popover. Compact, single-line
 * title case sized snugly to the longest label ("Filing Deadline") so the
 * label→value gutter stays tight and rows keep a uniform height.
 */
export const RowLabel: FC<ComponentProps<"span">> = ({
  className,
  ...props
}) => (
  <span
    {...props}
    className={cn(
      "flex w-26 shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-medium text-muted-foreground",
      className
    )}
  />
);

/** Clickable value cell in a property row. */
export const RowValueButton: FC<ComponentProps<"button">> = ({
  className,
  ...props
}) => (
  <button
    type="button"
    {...props}
    className={cn(
      "group/row flex h-7 min-w-0 flex-1 items-center gap-1.5 rounded-md px-1.5 text-left text-xs text-foreground transition-colors",
      "hover:bg-muted focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:outline-none",
      "data-[state=open]:bg-muted",
      className
    )}
  />
);
